export const isEmailValid = (email) => {
  const emailRegexp = /^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9_\-.]+\.[a-zA-Z]{2,5}$/;
  return emailRegexp.test(email);
};
